import {CheckboxValues} from '../../../../shared/components/payroll-checklist/checklist';
import {DropdownItem} from '../../../../shared/components/dropdown/dropdown.component';
import {Permission} from '../company/setting/settings';

export const COLORLIST = ['#4792de', '#77cbe4', '#78d28a', '#28b97b', '#488079', '#bb87e0', '#eca6e4', '#edad67', '#f3ce5e', '#ec7789'];
export const MAPMONTH = {
  January: 'มกราคม',
  February: 'กุมภาพันธ์',
  March: 'มีนาคม',
  April: 'เมษายน',
  May: 'พฤษภาคม',
  June: 'มิถุนายน',
  July: 'กรกฎาคม',
  August: 'สิงหาคม',
  September: 'กันยายน',
  October: 'ตุลาคม',
  November: 'พฤศจิกายน',
  December: 'ธันวาคม',
};

export const MONTHLIST = ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'];
export const MONTHSYNONYM = ['ม.ค.', 'ก.พ.', 'มี.ค.', 'เม.ย.', 'พ.ค.', 'มิ.ย.', 'ก.ค.', 'ส.ค.', 'ก.ย.', 'ต.ค.', 'พ.ย.', 'ธ.ค.'];

export const EXPENDITURECOLUMNS = 'expenditureColumns';
export const EXPENSECOLUMNS = 'expenseColumns';
export const INCOMECOLUMNS = 'incomeColumns';
export const EXPENSE = 'expense';
export const INCOME = 'income';
export const TotalWorkDay = 30;
export const TotalWorkHour = 8;

export interface PayrollList {
  Month: number;
  expanded?: boolean;
  installment: PayrollInstallment[];
  summary: PayrollInstallment;
}

export interface PayrollInstallment {
  id: string;
  status: string;
  pay_date: string;
  total_employees: number;
  TotalPayment: number;
}

export enum AddEditColumnsActions {
  add,
  edit,
  remove
}

export interface ExtraItem {
  id: string;
  label: string;
  isChecked: boolean;
  isFetchable: boolean;
  isFetchChecked: boolean;
}

export interface ColumnInput {
  name: string;
  autoFetch: boolean;
}

export interface PayrollColumnHeader {
  labelEn?: string;
  title: string;
  type: string;
  width: number;
  extra_column?: boolean;
  mask?: string;
  source?: string[];
  defaultValue?: string;
  required?: boolean;
  itemOrder?: number;
  onChange?: any;
  decimal?: string;
  name?: string;
  readOnly?: boolean;
  subDataName?: string;
  unit?: string;
  customReadOnly?: any;
  reference?: boolean;
}

export interface PayrollColumnFooter {
  name: string;
  summary: number | string;
  width: number;
  pay_tax?: CheckboxValues;
  transfer_to_account?: CheckboxValues;
  base_salary_adjustment?: CheckboxValues;
  extra_column?: boolean;
  hasAutoCal?: boolean;
  reduceSalary?: boolean;
  reference?: boolean;
}

export interface PayrollColumnDataValue {
  [key: string]: number | string;
}

export interface PayrollTotalData {
  total_income: number | string;
  total_expenditure: number | string;
  net_income: number | string;
  total_transfer_to_account: number | string;
}

export const PayrollStatus = {
  init: 'init',
  notPaid: 'not_paid',
  edit: 'edit',
  confirmed: 'confirmed',
  draft: 'draft'
};

export interface LeftSummary {
  ownerEmployee: number;
  ftEmployee: number;
  ptEmployee: number;
  salary: number;
  wht: number;
  ssoEmployer: number;
  ssoEmployee: number;
}

export const ListNestedHasTimeHeaderSettingUnits = [
  {id: 'hourly', name: 'ชั่วโมง'},
  {id: 'daily', name: 'วัน'}
];


export const listNestedHasTimeHeaderSetting = [
  {
    label: 'unit',
    lists: [{
      labelEn: 'wage',
      labelTh: 'วัน (ลูกจ้างรายวัน)',
      value: 'unit',
      timeUnit: 'daily',
      rate: 0, // cal by api
      column: INCOME
    }, {
      labelEn: 'holiday',
      labelTh: 'ชม. (ทำงานวันหยุด)',
      value: 'unit',
      timeUnit: 'hourly',
      rate: 1, // salary_period: "เดือน"
      rateSalaryPeriodDay: 2, // salary_period: "วัน"
      column: INCOME
    }, {
      labelEn: 'ot',
      labelTh: 'ชม. (OT)',
      value: 'unit',
      timeUnit: 'hourly',
      rate: 1.5,
      column: INCOME
    }, {
      labelEn: 'otHoliday',
      labelTh: 'ชม. (OT วันหยุด)',
      value: 'unit',
      timeUnit: 'hourly',
      rate: 3,
      column: INCOME
    }, {
      labelEn: 'late',
      labelTh: 'ชม. (มาสาย)',
      value: 'unit',
      timeUnit: 'hourly',
      rate: 1,
      column: EXPENSE
    }, {
      labelEn: 'absent',
      labelTh: 'ชม. (ลา / ขาดงาน / Leave without pay)',
      value: 'unit',
      timeUnit: 'hourly',
      rate: 1,
      column: EXPENSE
    }],
    type: 'numeric',
    mask: '#,##.00',
    decimal: '.',
    width: 65
  }, {
    label: '',
    lists: [{
      labelEn: 'wage',
      labelTh: 'ค่าจ้าง (ลูกจ้างรายวัน)',
      value: 'price',
      timeUnit: 'daily',
      rate: 0, // cal by api
      column: INCOME
    }, {
      labelEn: 'holiday',
      labelTh: 'ค่าทำงานวันหยุด',
      value: 'price',
      timeUnit: 'hourly',
      rate: 1, // salary_period: "เดือน"
      rateSalaryPeriodDay: 2, // salary_period: "วัน"
      column: INCOME
    }, {
      labelEn: 'ot',
      labelTh: 'OT ค่าล่วงเวลา',
      value: 'price',
      timeUnit: 'hourly',
      rate: 1.5,
      column: INCOME
    }, {
      labelEn: 'otHoliday',
      labelTh: 'OT ค่าล่วงเวลาวันหยุด',
      value: 'price',
      timeUnit: 'hourly',
      rate: 3,
      column: INCOME
    }, {
      labelEn: 'late',
      labelTh: 'มาสาย',
      value: 'price',
      timeUnit: 'hourly',
      rate: 1,
      column: EXPENSE
    }, {
      labelEn: 'absent',
      labelTh: 'ลา / ขาดงาน / Leave without pay',
      value: 'price',
      timeUnit: 'hourly',
      rate: 1,
      column: EXPENSE
    }],
    type: 'numeric',
    mask: '#,##.00',
    decimal: '.',
    width: 130
  }
];

export const CustomReadOnlyCols = ['wage', 'wageUnit', 'salary'];
export const listHasTime: string[] = ['wage', 'holiday', 'ot', 'otHoliday', 'late', 'absent'];
// All items in listHasTime must have timeUnit in INCOMELIST/EXPENSELIST 

export const SpecialExtendColumns = ['providentFundEmployer']
export const SpecialColumnPayroll = [
  {
    name: 'providentFund',
    title: '[ลูกจ้าง] กองทุนสำรองเลี้ยงชีพ',
    list: [{
      label: 'providentFundEmployer',
      labelTh: '[นายจ้าง] กองทุนสำรองเลี้ยงชีพ',
      extra_column: false,
      readOnly: false,
      reference: true,
    }]
  }
]

export enum CalType {
  sso = 'socialSecurity',
  wht = 'withholdingTax',
  pvd = 'providentFund',
  pvd_employer = 'providentFundEmployer',
  slf = 'studentLoan',
  payCut = 'payCut'
}

export enum FileName {
  payroll = 'payroll',
  payslip = 'payslip',
  sso = 'sso',
  pnd1 = 'pnd1',
  bank = 'bank',
  report = 'report',
  pnd1kor = 'pnd1kor',
  tv50 = 'tv50',
  kt20kor = 'kt20kor',
  reportAnnual = 'reportAnnual',
}

export const Files = [{
  name: 'payroll',
  id: 'bank_transfer_url',
  label: 'Payroll',
  image: '/assets/images/bank-logo/ico-payroll-bay.png',
  isDownload: true,
  isSendMail: false,
  isSendApp: false,
  isSendOut: true,
  isPnd: false,
  url: '',
  isMonth: true,
  isYear: false,
  hasConfirm: true,
  hasSubItem: false,
  permission: Permission.DownloadBankTransfer
}, {
  name: 'payslip',
  id: 'payslip_url',
  label: 'สลิปเงินเดือน',
  image: '/assets/images/bank-logo/ico-payroll-payslip.png',
  isDownload: true,
  isSendMail: true,
  isSendApp: false,
  isSendOut: false,
  isPnd: false,
  url: '',
  isMonth: true,
  isYear: false,
  hasConfirm: true,
  hasSubItem: true,
  permission: Permission.ViewEmployeeSalary
}, {
  name: 'pnd1',
  id: 'pnd1_url',
  label: 'ภ.ง.ด. 1',
  image: '/assets/images/bank-logo/ico-payroll-efiling.png',
  isDownload: true, // todo ถ้ายังไม่เอาเรื่องยื่ม efiling ขึ้น set = true
  isSendMail: false,
  isSendApp: false,
  isSendOut: true, // todo ถ้ายังไม่เอาเรื่องยื่ม efiling ขึ้น set = true
  isPnd: true,
  url: 'https://efiling.rd.go.th/rd-efiling-web/login',
  isMonth: true,
  isYear: false,
  hasConfirm: true,
  hasSubItem: false, // todo ถ้ายังไม่เอาเรื่องยื่ม efiling ขึ้น set = false
  permission: Permission.DownloadPND
}, {
  name: 'sso',
  id: 'sso_url',
  label: 'ส.ป.ส. 1-10',
  image: '/assets/images/bank-logo/ico-payroll-sso.png',
  isDownload: true,
  isSendMail: false,
  isSendApp: false,
  isSendOut: true,
  isPnd: false,
  url: 'https://www.sso.go.th/eservices/esv/login.do',
  isMonth: true,
  isYear: false,
  hasConfirm: false,
  hasSubItem: false,
  permission: Permission.DownloadSSO
}, {
  name: 'pnd1kor',
  id: 'pnd1kor_url',
  label: 'ภ.ง.ด. 1ก',
  image: '/assets/images/bank-logo/ico-payroll-rd.png',
  isDownload: true,
  isSendMail: false,
  isSendApp: false,
  isSendOut: true,
  isPnd: false,
  url: 'https://efiling.rd.go.th/rd-efiling-web/login',
  isYear: true,
  hasConfirm: false,
  hasSubItem: false,
  permission: Permission.DownloadPND
}, {
  name: 'tv50',
  id: 'tv50_url',
  label: 'ใบ 50 ทวิ',
  image: '/assets/images/bank-logo/ico-payroll-wht.png',
  isDownload: true,
  isSendMail: false,
  isSendApp: false,
  isSendOut: false,
  isPnd: false,
  url: '',
  isYear: true,
  hasConfirm: false,
  hasSubItem: false,
  permission: Permission.ViewEmployeeSalary
}, {
  name: 'kt20kor',
  id: 'kt20kor_url',
  label: 'กท. 20ก',
  image: '/assets/images/bank-logo/ico-payroll-sso.png',
  isDownload: true,
  isSendMail: false,
  isSendApp: false,
  isSendOut: true,
  isPnd: false,
  url: 'https://www.sso.go.th/eservices/esv/login.do',
  isMonth: false,
  isYear: true,
  hasConfirm: false,
  hasSubItem: false,
  permission: Permission.DownloadSSO
}, {
  name: 'report',
  id: 'report_url',
  label: 'รายงาน',
  image: '/assets/images/bank-logo/ico-payroll-excel.png',
  isDownload: true,
  isSendMail: false,
  isSendApp: false,
  isSendOut: false,
  isPnd: false,
  url: '',
  isMonth: true,
  isYear: false,
  hasConfirm: true,
  hasSubItem: false,
  permission: Permission.DownloadReport
}, {
  name: 'reportAnnual',
  id: 'reportAnnual_url',
  label: 'รายงาน',
  image: '/assets/images/bank-logo/ico-payroll-excel.png',
  isDownload: true,
  isSendMail: false,
  isSendApp: false,
  isSendOut: false,
  isPnd: false,
  url: '',
  isMonth: false,
  isYear: true,
  hasConfirm: true,
  hasSubItem: false,
  permission: Permission.DownloadReport
}];

export const expenseHasChanged = 'expenseHasChanged';
export const timeUnitPriceHasChanged = 'timeUnitPriceHasChanged';

export const AutocalCheckboxList = [{
  labelTh: 'ภาษีหัก ณ ที่จ่าย',
  labelEn: 'withholdingTax',
  type: 'wht',
  isChecked: false
}, {
  labelTh: 'ประกันสังคม',
  labelEn: 'socialSecurity',
  type: 'sso',
  isChecked: false
}, {
  labelTh: '[ลูกจ้าง] กองทุนสำรองเลี้ยงชีพ',
  labelEn: 'providentFund',
  type: 'pvd',
  isChecked: false
}, {
  labelTh: '[นายจ้าง] กองทุนสำรองเลี้ยงชีพ',
  labelEn: 'providentFundEmployer',
  type: 'pvd_employer',
  isChecked: false
}, {
  labelTh: 'กยศ.',
  labelEn: 'studentLoan',
  type: 'slf',
  isChecked: false
}];

export enum EmployeeType {
  current = 'current',
  old = 'old'
}

export const TIMES: DropdownItem[] = [{
  label: '00:00',
  value: '00:00',
  id: 0
}, {
  label: '01:00',
  value: '01:00',
  id: 1
}, {
  label: '02:00',
  value: '02:00',
  id: 2
}, {
  label: '03:00',
  value: '03:00',
  id: 3
}, {
  label: '04:00',
  value: '04:00',
  id: 4
}, {
  label: '05:00',
  value: '05:00',
  id: 5
}, {
  label: '06:00',
  value: '06:00',
  id: 6
}, {
  label: '07:00',
  value: '07:00',
  id: 7
}, {
  label: '08:00',
  value: '08:00',
  id: 8
}, {
  label: '09:00',
  value: '09:00',
  id: 9
}, {
  label: '10:00',
  value: '10:00',
  id: 10
}, {
  label: '11:00',
  value: '11:00',
  id: 11
}, {
  label: '12:00',
  value: '12:00',
  id: 12
}, {
  label: '13:00',
  value: '13:00',
  id: 13
}, {
  label: '14:00',
  value: '14:00',
  id: 14
}, {
  label: '15:00',
  value: '15:00',
  id: 15
}, {
  label: '16:00',
  value: '16:00',
  id: 16
}, {
  label: '17:00',
  value: '17:00',
  id: 17
}, {
  label: '18:00',
  value: '18:00',
  id: 18
}, {
  label: '19:00',
  value: '19:00',
  id: 19
}, {
  label: '20:00',
  value: '20:00',
  id: 20
}, {
  label: '21:00',
  value: '21:00',
  id: 21
}, {
  label: '22:00',
  value: '22:00',
  id: 22
}, {
  label: '23:00',
  value: '23:00',
  id: 23
}];
